"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeEmailTypeForContactInfoEdit = normalizeEmailTypeForContactInfoEdit;
exports.normalizeEmailTypeForEdit = normalizeEmailTypeForEdit;
exports.normalizePhoneTypeForContactInfoEdit = normalizePhoneTypeForContactInfoEdit;
exports.normalizePhoneTypeForEdit = normalizePhoneTypeForEdit;
exports.toSavedHeadingEmailType = toSavedHeadingEmailType;
exports.toSavedHeadingPhoneType = toSavedHeadingPhoneType;
var _textUtils = require("../../textUtils");
function normalizePhoneTypeForEdit(value) {
  const label = (0, _textUtils.toTypeLabel)(value).trim().toLowerCase();
  if (!label) return '';
  if (label === 'cell' || label === 'mobile') return 'Mobile';
  if (label === 'home') return 'Home';
  if (label === 'work' || label === 'office') return 'Work';
  return '';
}
function normalizePhoneTypeForContactInfoEdit(value) {
  const label = (0, _textUtils.toTypeLabel)(value).trim().toLowerCase();
  if (!label) return '';
  if (label === 'cell' || label === 'mobile') return 'Cell';
  if (label === 'home') return 'Home';
  if (label === 'work' || label === 'office') return 'Work';
  return '';
}
function normalizeEmailTypeForEdit(value) {
  const label = (0, _textUtils.toTypeLabel)(value).trim().toLowerCase();
  if (!label) return '';
  if (label === 'personal' || label === 'home') return 'Personal';
  if (label === 'office' || label === 'work') return 'Office';
  return '';
}
function normalizeEmailTypeForContactInfoEdit(value) {
  const label = (0, _textUtils.toTypeLabel)(value).trim().toLowerCase();
  if (!label) return '';
  if (label === 'personal' || label === 'home') return 'Home';
  if (label === 'office' || label === 'work') return 'Office';
  return '';
}
function toSavedHeadingEmailType(type) {
  return type === 'Personal' ? 'Home' : type || '';
}
function toSavedHeadingPhoneType(type) {
  return type === 'Mobile' ? 'Cell' : type || '';
}